module.exports = __webpack_public_path__ + "static/media/Arrowright.d37a49ad.svg";